import './index.scss';
import { updateFreemiumCounter } from 'utils/freemium';

export function runPreTextScript() {
  $('.q-lesson-freemium-pre-text button')
    .off('click')
    .on('click', event => {
      const $lesson = $(event.currentTarget.closest('.q-track-text'));
      $lesson.addClass('lesson-opened');

      updateFreemiumCounter('lessons');
    });
}
